/* Tri-tennis: vertalingen voor vaste teksten in eigen onderdelen (huurmodule, logo-configurator, offerte, subsidie, retourpakket) */
(function () {
  var L = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var X = window.TT_I18N; if (!X || L === 'en') return;
  var D = X.D, H = X.H || {};
  var EXTRA = {
    'ADD TO CART': { de: 'IN DEN WARENKORB', fr: 'AJOUTER AU PANIER', nl: 'IN WINKELWAGEN', es: 'AÑADIR AL CARRITO' },
    'CHOOSE OPTIONS': { de: 'OPTIONEN WÄHLEN', fr: 'CHOISIR LES OPTIONS', nl: 'OPTIES KIEZEN', es: 'ELEGIR OPCIONES' },
    'Add to cart': { de: 'In den Warenkorb', fr: 'Ajouter au panier', nl: 'In winkelwagen', es: 'Añadir al carrito' },
    'Close': { de: 'Schließen', fr: 'Fermer', nl: 'Sluiten', es: 'Cerrar' }
  };
  Object.keys(EXTRA).forEach(function (k) { if (!D[k] && EXTRA[k][L]) D[k] = EXTRA[k][L]; });
  var MON = {}, WD = {}, WD2 = {}; MON[L] = X.MON; WD[L] = X.WD; WD2[L] = X.WD2;
  var PAT = X.PAT.map(function (p) { var o = {}; o[L] = p[1]; return [p[0], o]; });
  var M_EN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var WD_EN = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var WD2_EN = ['Mo','Tu','We','Th','Fr','Sa','Su'];
  var pats = PAT.map(function (p) { return [new RegExp(p[0]), p[1][L]]; });
  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }
  function dates(t) {
    t = t.replace(/\b(January|February|March|April|May|June|July|August|September|October|November|December)\b/g, function (m) { return MON[L][M_EN.indexOf(m)]; });
    t = t.replace(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g, function (m) { var i = M_EN.map(function (x) { return x.slice(0, 3); }).indexOf(m); var n = MON[L][i]; return n.length > 4 ? n.slice(0, 3) + '.' : n; });
    t = t.replace(/\b(Sun|Mon|Tue|Wed|Thu|Fri|Sat)\b/g, function (m) { return WD[L][WD_EN.indexOf(m)]; });
    return t;
  }
  function tr(raw, inRental) {
    var t = norm(raw); if (!t) return null;
    if (D[t]) return raw.replace(raw.trim(), D[t]);
    for (var i = 0; i < pats.length; i++) {
      var m = t.match(pats[i][0]);
      if (m) { var out = pats[i][1]; for (var j = 1; j < m.length; j++) out = out.split('$' + j).join(inRental ? dates(m[j]) : m[j]); return out; }
    }
    if (/^Your logo: /.test(t)) { var opt = t.replace(/^Your logo: /, ''); return (D['Logo position'] || 'Logo') + ': ' + (D[opt.charAt(0).toUpperCase() + opt.slice(1)] || D[opt] || opt); }
    if (/^Please .+\.$/.test(t)) {
      var parts = t.slice(7, -1).split(' and ');
      if (parts.every(function (p) { return D[p]; })) return ({ de: 'Bitte ', fr: 'Veuillez ', nl: 'Graag: ', es: 'Por favor, ' }[L]) + parts.map(function (p) { return D[p]; }).join({ de: ' und ', fr: ' et ', nl: ' en ', es: ' y ' }[L]) + '.';
    }
    if (inRental) {
      var w2 = WD2_EN.indexOf(t); if (w2 > -1) return WD2[L][w2];
      var d = dates(t); if (d !== t) return d;
    }
    return null;
  }
  var ROOTS = '.th-rental, .tt-lc, .tt-qb, .tt-sp, .tt-sub, .tt-try, .tt-kf, .tt-loc, .tt-top, .tt-ic, .tt-cp, .tt-rv, .tt-geo, .overlay_atc_btn, .custon_link, .sticky_btn_main, [data-tt-i18n]';
  function inScope(el) { return el && el.closest && el.closest(ROOTS); }
  function doEl(el) {
    if (!el || el.nodeType !== 1 || el.closest('script,style,select option[value=""]')) return;
    ['placeholder', 'aria-label', 'title', 'alt'].forEach(function (a) {
      if (el.hasAttribute && el.hasAttribute(a)) { var v = tr(el.getAttribute(a), !!el.closest('.th-rental')); if (v) el.setAttribute(a, v); }
    });
    if (el.children.length && el.children.length <= 3 && [].every.call(el.children, function (c) { return /^(STRONG|B|EM|I|A|BR)$/.test(c.tagName); })) {
      var key = norm(el.textContent);
      if (H[key]) { el.innerHTML = H[key]; return; }
    }
  }
  function doText(n) {
    var p = n.parentElement; if (!p || /^(SCRIPT|STYLE|TEXTAREA)$/.test(p.tagName)) return;
    var v = tr(n.nodeValue, !!p.closest('.th-rental')); if (v && v !== n.nodeValue) n.nodeValue = v;
  }
  function run(root) {
    if (root.nodeType === 3) { if (inScope(root.parentElement)) doText(root); return; }
    if (root.nodeType !== 1) return;
    var scopes = inScope(root) ? [root] : [].slice.call(root.querySelectorAll(ROOTS));
    scopes.forEach(function (s) {
      doEl(s); [].slice.call(s.querySelectorAll('*')).forEach(doEl);
      var w = document.createTreeWalker(s, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) list.push(n);
      list.forEach(doText);
    });
  }
  var busy = false;
  function start() {
    run(document.body);
    new MutationObserver(function (ms) {
      if (busy) return; busy = true;
      ms.forEach(function (m) {
        if (m.type === 'characterData') { if (inScope(m.target.parentElement)) doText(m.target); }
        else m.addedNodes.forEach(function (n) { run(n); });
      });
      busy = false;
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();